import log from 'loglevel'
import axios from 'axios'
import User from './user'

import Cache from '../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class Commission {
  constructor() {
    log.info('[INFO] Initialize Commission Module')
    this.user = new User()
    this.cache = new Cache()
  }

  fetchAllCommissions(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/commission/commission/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch commissions')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch commissions')
            log.error(error)
            reject(error.response)
          })
      })

      return promise
    })

    return result
  }

  fetchCommission(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/commission/commission/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch commission')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch commission')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateCommission(id, commissionData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/commission/commission/${id}/`, commissionData)
        .then(response => {
          log.debug('[DEBUG] Success to update commission')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update commission')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addCommission(commissionData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/commission/commission/', commissionData)
        .then(response => {
          log.debug('[DEBUG] Success to add commission')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add commission')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteCommission(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/commission/commission/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete commission')
          this.cache.reset()
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete commission')
          log.error(error)
          reject(error.response)
        })
    })
  }

  fetchCommissionsFromInvoicing(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/commission/commission/from/invoicing/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch commissions from invoicing')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch commissions from invoicing')
            log.error(error)
            reject(error.response)
          })
      })

      return promise
    })

    return result
  }

  fetchCommissionsFromInvoicingId(id, params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    return new Promise((resolve, reject) => {
      axios
        .get(`v1/commission/commission/from/invoicing/${id}/`, parameters)
        .then(response => {
          log.debug('[DEBUG] Success to fetch commissions from invoicing')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch commissions from invoicing')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
